(function (window, document) {
  'use strict';
  var ROOT_SELECTOR = '[data-gcp-hk-public-data]';
  var REQUEST_EVENT = 'gcitypartners:opportunities:request';
  function clean(value) {
    return String(value == null ? '' : value).trim();
  }
  function words(runtime, zh, en) {
    return /^zh/i.test(
      runtime.root.getAttribute('data-locale') || document.documentElement.lang || ''
    )
      ? zh
      : en;
  }
  function object(value) {
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  }
  function unwrap(payload) {
    return Object.keys(object(payload.data)).length ? payload.data : payload;
  }
  function element(tag, text) {
    var node = document.createElement(tag);
    if (text != null) node.textContent = text;
    return node;
  }
  function sourceLink(value, label) {
    try {
      var url = new URL(value);
      if (
        url.protocol !== 'https:' ||
        url.username ||
        url.password ||
        !/(^|\.)gov\.hk$/.test(url.hostname)
      )
        return null;
      var link = element('a', label || url.hostname);
      link.href = url.href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      return link;
    } catch (_) {
      return null;
    }
  }
  function addSource(node, url, label) {
    var link = sourceLink(url, label);
    if (link) node.appendChild(link);
  }
  function time(node, value, runtime) {
    if (!clean(value)) return;
    var stamp = element('small', words(runtime, '資料時間：', 'Data time: ') + clean(value));
    node.appendChild(stamp);
  }
  function abort(slot) {
    if (slot && slot.controller) slot.controller.abort();
  }
  function aggregate(runtime) {
    var states = Object.keys(runtime.states).map(function (key) {
      return runtime.states[key];
    });
    var ready = states.some(function (state) {
      return state === 'ready' || state === 'partial' || state === 'stale';
    });
    var limited = states.indexOf('rate-limited') !== -1;
    var unavailable = states.indexOf('unavailable') !== -1;
    var state = limited
      ? ready
        ? 'partial'
        : 'rate-limited'
      : unavailable
        ? ready
          ? 'partial'
          : 'unavailable'
        : states.indexOf('partial') !== -1 || states.indexOf('stale') !== -1
          ? 'partial'
          : states.indexOf('loading') !== -1
            ? 'loading'
            : ready
              ? 'ready'
              : 'idle';
    runtime.root.setAttribute('data-state', state);
    var label = runtime.root.querySelector('[data-hk-status]');
    label.textContent =
      state === 'loading'
        ? words(runtime, '正在讀取公共資料…', 'Loading public data…')
        : state === 'partial'
          ? words(
              runtime,
              '部分資料可用；請查看各來源狀態。',
              'Some data is available; check each source status.'
            )
          : state === 'rate-limited'
            ? words(runtime, '已達查詢額度；請稍後重試。', 'Request limit reached; retry later.')
            : state === 'unavailable'
              ? words(runtime, '公共資料暫時不可用。', 'Public data is temporarily unavailable.')
              : '';
  }
  function mark(runtime, key, state) {
    runtime.states[key] = state;
    var node = runtime.root.querySelector('[data-hk-' + key + ']');
    if (node) node.setAttribute('data-state', state);
    aggregate(runtime);
  }
  function failed(runtime, key, error) {
    var node = runtime.root.querySelector('[data-hk-' + key + ']');
    if (!node) return;
    if (key === 'warnings') node.removeAttribute('data-active-warnings');
    var limited = error.status === 429;
    node.replaceChildren(
      element(
        'p',
        limited
          ? words(runtime, '已達查詢額度；請稍後重試。', 'Request limit reached; retry later.')
          : words(
              runtime,
              '來源暫時不可用；這不代表沒有資料。',
              'Source unavailable; this does not mean there is no data.'
            )
      )
    );
    if (limited && error.retryAfter)
      node.appendChild(
        element(
          'small',
          words(runtime, '請等待約 ', 'Wait about ') +
            error.retryAfter +
            words(runtime, ' 秒。', ' seconds.')
        )
      );
    if (key === 'current' || key === 'warnings' || key === 'forecast' || key === 'nine-day')
      addSource(node, 'https://www.hko.gov.hk/', 'HKO ↗');
    if (key === 'air') addSource(node, 'https://www.aqhi.gov.hk/', 'AQHI ↗');
    mark(runtime, key, limited ? 'rate-limited' : 'unavailable');
  }
  function endpointUrl(runtime, path, params) {
    var base = runtime.root.getAttribute('data-public-data-base');
    var url = new URL(
      base.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, ''),
      window.location.origin
    );
    Object.keys(params || {}).forEach(function (key) {
      if (params[key] != null && params[key] !== '') url.searchParams.set(key, String(params[key]));
    });
    return url.href;
  }
  function request(runtime, key, path, params, render, force) {
    var requestKey = path + '?' + new URLSearchParams(params || {}).toString();
    var previous = runtime.requests[key];
    if (
      !force &&
      previous &&
      previous.key === requestKey &&
      (previous.pending || (previous.loaded && Date.now() - previous.loadedAt < 60000))
    )
      return previous.promise;
    abort(previous);
    var slot = {
      key: requestKey,
      controller: new window.AbortController(),
      pending: true,
      loaded: false,
    };
    runtime.requests[key] = slot;
    mark(runtime, key, 'loading');
    slot.promise = Promise.resolve()
      .then(function () {
        if (!runtime.active || runtime.destroyed || runtime.requests[key] !== slot)
          throw Object.assign(new Error('request_aborted'), { name: 'AbortError' });
        return window.fetch(endpointUrl(runtime, path, params), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: slot.controller.signal,
        });
      })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            throw Object.assign(new Error('invalid_json'), { status: response.status });
          })
          .then(function (payload) {
            if (
              !response.ok ||
              payload.ok === false ||
              payload.success === false ||
              payload.status === 'unavailable'
            )
              throw Object.assign(new Error('source_unavailable'), {
                status: response.status,
                retryAfter: response.headers.get('Retry-After'),
              });
            return payload;
          });
      })
      .then(function (payload) {
        if (!runtime.active || runtime.destroyed || runtime.requests[key] !== slot) return;
        render(unwrap(payload), payload);
        slot.loaded = true;
        slot.loadedAt = Date.now();
      })
      .catch(function (error) {
        if (
          error.name === 'AbortError' ||
          !runtime.active ||
          runtime.destroyed ||
          runtime.requests[key] !== slot
        )
          return;
        failed(runtime, key, error);
        if (key === 'current' && path === '/api/weather/summary')
          failed(runtime, 'warnings', error);
      })
      .finally(function () {
        slot.pending = false;
      });
    return slot.promise;
  }
  function renderCurrent(runtime, data) {
    var node = runtime.root.querySelector('[data-hk-current]');
    var current = object(data.current || data),
      temperature = object(current.temperature);
    var value = typeof current.temperature === 'number' ? current.temperature : temperature.value;
    if (typeof value !== 'number' || !Number.isFinite(value))
      throw new Error('invalid_temperature');
    node.replaceChildren(element('strong', words(runtime, '現時約 ', 'Around ') + value + '°C'));
    var forecast = object(data.local_forecast);
    node.appendChild(
      element(
        'span',
        clean(forecast.forecast_description) ||
          words(
            runtime,
            '出發前請核對香港天文台最新預報及警告。',
            'Check the latest HKO forecast and warnings before departure.'
          )
      )
    );
    if (temperature.place) node.appendChild(element('small', clean(temperature.place)));
    time(node, current.updated_at || temperature.recorded_at || data.last_updated_at, runtime);
    addSource(node, current.official_url || 'https://www.hko.gov.hk/', 'HKO ↗');
    mark(runtime, 'current', 'ready');
  }
  function renderWarnings(runtime, data) {
    var node = runtime.root.querySelector('[data-hk-warnings]');
    var rows = Array.isArray(data.warnings) ? data.warnings : data.items;
    if (!Array.isArray(rows)) throw new Error('invalid_warnings');
    node.replaceChildren();
    if (!rows.length)
      node.appendChild(
        element(
          'p',
          words(
            runtime,
            '目前未有生效天氣警告；出發前請再次核對 HKO。',
            'No active weather warnings reported; check HKO again before departure.'
          )
        )
      );
    rows.forEach(function (item) {
      var article = element('article');
      article.appendChild(
        element('strong', [item.name, item.code, item.action].filter(Boolean).join(' · '))
      );
      if (Array.isArray(item.contents))
        item.contents.forEach(function (text) {
          article.appendChild(element('p', clean(text)));
        });
      time(article, item.updated_at || item.issued_at, runtime);
      node.appendChild(article);
    });
    if (Array.isArray(data.special_tips))
      data.special_tips.forEach(function (tip) {
        node.appendChild(element('p', clean(tip)));
      });
    time(node, data.updated_at || data.last_updated_at, runtime);
    addSource(node, 'https://www.hko.gov.hk/', 'HKO ↗');
    node.setAttribute('data-active-warnings', String(rows.length));
    mark(runtime, 'warnings', 'ready');
  }
  function renderForecast(runtime, data) {
    var node = runtime.root.querySelector('[data-hk-forecast]');
    var local = object(data.local_forecast || data);
    if (!clean(local.forecast_description)) throw new Error('invalid_forecast');
    node.replaceChildren(element('p', clean(local.forecast_description)));
    if (local.outlook) node.appendChild(element('p', clean(local.outlook)));
    time(node, local.updated_at || data.last_updated_at, runtime);
    addSource(node, 'https://www.hko.gov.hk/', 'HKO ↗');
    mark(runtime, 'forecast', 'ready');
  }
  function renderDays(runtime, data) {
    var node = runtime.root.querySelector('[data-hk-nine-day]');
    var days = Array.isArray(data.nine_day) ? data.nine_day : data.items;
    if (!Array.isArray(days) || !days.length) throw new Error('invalid_nine_day');
    node.replaceChildren();
    days.forEach(function (day) {
      node.appendChild(
        element(
          'p',
          [
            day.forecast_date,
            day.week,
            day.weather,
            day.min_temp_c != null && day.max_temp_c != null
              ? day.min_temp_c + '–' + day.max_temp_c + '°C'
              : '',
          ]
            .filter(Boolean)
            .join(' · ')
        )
      );
    });
    time(node, data.updated_at || data.last_updated_at, runtime);
    addSource(node, 'https://www.hko.gov.hk/', 'HKO ↗');
    mark(runtime, 'nine-day', 'ready');
  }
  function loadForecast(runtime, force) {
    if (runtime.summary && !force) {
      try {
        renderForecast(runtime, runtime.summary);
      } catch (error) {
        failed(runtime, 'forecast', error);
      }
      try {
        renderDays(runtime, runtime.summary);
      } catch (error) {
        failed(runtime, 'nine-day', error);
      }
      return;
    }
    request(
      runtime,
      'forecast',
      '/api/weather/local-forecast',
      {},
      function (data) {
        renderForecast(runtime, data);
      },
      force
    );
    request(
      runtime,
      'nine-day',
      '/api/weather/nine-day',
      {},
      function (data) {
        renderDays(runtime, data);
      },
      force
    );
  }
  function renderAir(runtime, data) {
    var node = runtime.root.querySelector('[data-hk-air]');
    if (
      typeof data.aqhi !== 'number' ||
      !Number.isFinite(data.aqhi) ||
      !data.station_id ||
      !data.observed_at
    )
      throw new Error('invalid_aqhi');
    node.replaceChildren(
      element(
        'strong',
        'AQHI ' + data.aqhi + (data.risk_level ? ' · ' + clean(data.risk_level) : '')
      ),
      element('span', clean(data.station_id))
    );
    time(node, data.observed_at, runtime);
    node.appendChild(element('small', clean(data.source)));
    if (data.status === 'stale')
      node.appendChild(
        element(
          'p',
          words(
            runtime,
            '這是較早的觀測，並非即時數值。',
            'This is an earlier observation, not a live value.'
          )
        )
      );
    addSource(node, 'https://www.aqhi.gov.hk/', 'AQHI ↗');
    mark(runtime, 'air', data.status === 'stale' ? 'stale' : 'ready');
  }
  function loadWeather(runtime, force) {
    request(
      runtime,
      'current',
      '/api/weather/summary',
      {},
      function (data) {
        renderCurrent(runtime, data);
        runtime.summary = data;
        try {
          renderWarnings(runtime, data);
        } catch (error) {
          failed(runtime, 'warnings', error);
        }
        if (runtime.forecast.open) loadForecast(runtime, false);
      },
      force
    ).then(function () {
      if (!runtime.active || runtime.destroyed) return;
      if (runtime.states.current === 'unavailable')
        request(
          runtime,
          'current',
          '/api/weather/current',
          {},
          function (data) {
            renderCurrent(runtime, data);
          },
          force
        );
      if (runtime.states.warnings === 'unavailable')
        request(
          runtime,
          'warnings',
          '/api/weather/warnings',
          {},
          function (data) {
            renderWarnings(runtime, data);
          },
          force
        );
    });
    request(
      runtime,
      'air',
      '/api/air-quality/current',
      {},
      function (data) {
        renderAir(runtime, data);
      },
      force
    );
  }
  function locationContext(value) {
    var lat = clean(value.latitude),
      lng = clean(value.longitude);
    if (!lat || !lng) return null;
    var latitude = Number(lat),
      longitude = Number(lng);
    return Number.isFinite(latitude) &&
      Number.isFinite(longitude) &&
      latitude >= 22.1 &&
      latitude <= 22.6 &&
      longitude >= 113.8 &&
      longitude <= 114.5
      ? { lat: latitude, lng: longitude }
      : null;
  }
  function placeName(item) {
    return clean(item.display_name || object(item.name).zh_hk || object(item.name).en || item.name);
  }
  function renderPlace(node, item, runtime) {
    node.appendChild(element('strong', placeName(item)));
    var address = object(item.address);
    node.appendChild(
      element(
        'p',
        clean(address.zh_hk || address.en || (typeof item.address === 'string' ? item.address : ''))
      )
    );
    var source = object(item.source);
    if (source.attribution) node.appendChild(element('small', clean(source.attribution)));
    time(node, source.retrieved_at || source.verified_at, runtime);
    addSource(
      node,
      item.official_url || source.official_url || source.source_page || source.url,
      words(runtime, '官方來源 ↗', 'Official source ↗')
    );
  }
  function loadPlaces(runtime, context, force) {
    if (!context) return;
    runtime.location = context;
    abort(runtime.requests.detail);
    delete runtime.requests.detail;
    delete runtime.states.detail;
    runtime.root.querySelector('[data-hk-detail]').replaceChildren();
    request(
      runtime,
      'places',
      '/api/explore/places',
      Object.assign({ limit: 6 }, context),
      function (data, payload) {
        if (!Array.isArray(data.items)) throw new Error('invalid_places');
        var node = runtime.root.querySelector('[data-hk-places]');
        node.replaceChildren();
        if (!data.items.length)
          node.appendChild(
            element(
              'p',
              words(runtime, '此位置條件未返回地點。', 'No places returned for this location.')
            )
          );
        data.items.forEach(function (item) {
          if (!clean(item.id)) return;
          var article = element('article');
          renderPlace(article, item, runtime);
          var button = element('button', words(runtime, '查看詳情', 'View details'));
          button.type = 'button';
          button.setAttribute('data-hk-place-id', item.id);
          article.appendChild(button);
          node.appendChild(article);
        });
        if (Array.isArray(data.sources))
          data.sources.forEach(function (source) {
            var row = element('small', clean(source.id) + ' · ' + clean(source.status));
            addSource(row, source.source_page, words(runtime, '來源 ↗', 'Source ↗'));
            node.appendChild(row);
          });
        mark(runtime, 'places', payload.status === 'partial' ? 'partial' : 'ready');
      },
      force
    );
  }
  function update(root, context) {
    var runtime = root && root.__gcpHKPublicData;
    if (!runtime) return;
    var valid = locationContext(context || {});
    if (valid && runtime.active) loadPlaces(runtime, valid, false);
  }
  function pause(runtime) {
    runtime.active = false;
    Object.keys(runtime.requests).forEach(function (key) {
      var slot = runtime.requests[key];
      if (slot.pending) {
        abort(slot);
        delete runtime.requests[key];
        delete runtime.states[key];
      }
    });
    aggregate(runtime);
  }
  function destroy(root) {
    var runtime = root && root.__gcpHKPublicData;
    if (!runtime) return;
    runtime.destroyed = true;
    pause(runtime);
    runtime.host.removeEventListener(REQUEST_EVENT, runtime.onRequest);
    root.removeEventListener('click', runtime.onClick);
    root.removeEventListener('submit', runtime.onSubmit);
    runtime.forecast.removeEventListener('toggle', runtime.onForecast);
    root.__gcpHKPublicData = null;
  }
  function init(root) {
    if (!root || root.__gcpHKPublicData) return;
    var host = root.closest('[data-gcitypartners-page-system]');
    if (!host) return;
    var runtime = {
      root: root,
      host: host,
      active: false,
      destroyed: false,
      summary: null,
      requests: {},
      states: {},
      location: null,
      forecast: root.querySelector('[data-hk-forecast-toggle]'),
    };
    runtime.onRequest = function (event) {
      if (event.target !== host) return;
      if (event.detail && event.detail.type === 'programme') {
        runtime.active = true;
        loadWeather(runtime, false);
      } else pause(runtime);
    };
    runtime.onForecast = function () {
      if (runtime.forecast.open && runtime.active) loadForecast(runtime, false);
    };
    runtime.onSubmit = function (event) {
      if (!event.target.matches('[data-hk-location-form]')) return;
      event.preventDefault();
      var form = event.target;
      var context = locationContext({
        latitude: form.elements.latitude.value,
        longitude: form.elements.longitude.value,
      });
      var validation = root.querySelector('[data-hk-location-status]');
      validation.textContent = context
        ? ''
        : words(
            runtime,
            '請輸入有效香港位置的緯度和經度。',
            'Enter valid latitude and longitude for a Hong Kong location.'
          );
      if (context && runtime.active) loadPlaces(runtime, context, false);
    };
    runtime.onClick = function (event) {
      var target = event.target.closest('[data-hk-refresh], [data-hk-place-id]');
      if (!target || !root.contains(target) || !runtime.active) return;
      if (target.hasAttribute('data-hk-refresh')) {
        runtime.summary = null;
        loadWeather(runtime, true);
        if (runtime.forecast.open) loadForecast(runtime, true);
        return;
      }
      var id = clean(target.getAttribute('data-hk-place-id'));
      if (!id || id.length > 160) return;
      request(
        runtime,
        'detail',
        '/api/explore/place',
        { place_id: id },
        function (data) {
          if (!data.item || data.item.id !== id) throw new Error('invalid_place');
          var node = root.querySelector('[data-hk-detail]');
          node.replaceChildren();
          renderPlace(node, data.item, runtime);
          mark(runtime, 'detail', 'ready');
        },
        false
      );
    };
    root.__gcpHKPublicData = runtime;
    var registry = window.GCityExecutor && window.GCityExecutor.ENDPOINT_REGISTRY;
    if (registry)
      ['current', 'local-forecast', 'nine-day', 'warnings', 'summary'].forEach(function (kind) {
        var path = '/api/weather/' + kind;
        if (!registry[path])
          registry[path] = {
            api_family: 'gcity-core-api',
            api_tier: 'daily_platform',
            delivery_type: 'api',
            delivery_method: 'instant',
            engine_type: 'decision_engine',
            result_surface: 'panel',
            requires_gfun: false,
            read_only: true,
            canonical_endpoint: path,
          };
      });
    host.addEventListener(REQUEST_EVENT, runtime.onRequest);
    root.addEventListener('click', runtime.onClick);
    root.addEventListener('submit', runtime.onSubmit);
    runtime.forecast.addEventListener('toggle', runtime.onForecast);
    var tools = host.querySelector('[data-gcp-programme-tools]');
    if (tools && !tools.hidden) {
      runtime.active = true;
      loadWeather(runtime, false);
    }
  }
  function boot(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    if (container.matches && container.matches(ROOT_SELECTOR)) init(container);
    container.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }
  window.GCityPartnersHKPublicData = { init: boot, update: update, destroy: destroy };
  if (!window.__gcpHKPublicDataLifecycle) {
    window.__gcpHKPublicDataLifecycle = true;
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target instanceof Element || event.target instanceof Document) boot(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches(ROOT_SELECTOR)) destroy(target);
      if (target && target.querySelectorAll)
        target.querySelectorAll(ROOT_SELECTOR).forEach(destroy);
    });
    window.addEventListener('pagehide', function () {
      document.querySelectorAll(ROOT_SELECTOR).forEach(destroy);
    });
    window.addEventListener('pageshow', function () {
      boot();
    });
  }
  if (document.readyState === 'loading')
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot();
      },
      { once: true }
    );
  else boot();
})(window, document);
